import React, { FunctionComponent } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

export const queryClientOptions = {
  defaultOptions: {
    queries: {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  },
};
export const queryClient = new QueryClient(queryClientOptions);

type Props = {
  customClient?: QueryClient;
};

const AppQueryClientProvider: FunctionComponent<Props> = ({ children, customClient }) => (
  <QueryClientProvider client={customClient || queryClient}>
    {children}
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </QueryClientProvider>
);

export default AppQueryClientProvider;
